module.exports = __webpack_public_path__ + "img/20180815_151629_185.d26b6c37.jpg";